<script lang="ts">
  import { Dialog as DialogPrimitive } from "bits-ui";
  import { cn } from "$utils/ui";

  type $$Props = DialogPrimitive.DescriptionProps;

  let className: $$Props["class"] = undefined;
  export { className as class };
</script>

<DialogPrimitive.Description class={cn("text-base p", className)} {...$$restProps}>
  <slot />
</DialogPrimitive.Description>
